<div class="view-lead-details-container">
  <!-- Error Notification -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>

  <!-- Success Notification -->
  <div *ngIf="successMessage" class="success-notification">
    <svg class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M9 12L11 14L15 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="success-notification-message">{{ successMessage }}</span>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading lead details...</p>
  </div>

  <!-- Lead Details -->
  <div *ngIf="!loading && lead && product" class="lead-details-content">
    <!-- Header with Back Button, Title, Status Badge, and Print Button -->
    <div class="page-header">
      <!-- Top Bar: Back Arrow, Title, Status Badge, Print Button -->
      <div class="header-top-bar">
        <button class="btn-back" (click)="goBack()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <h2 class="">{{ product?.name || 'N/A' }}</h2>
        <span class="status-badge" [ngClass]="crrntStatus">
          {{ currentText}}
        
          
        </span>
        <button class="btn-print" (click)="printPage()">
          <img src="assets/public/print.png" alt="Print" class="print-icon">
          <span>Print</span>
        </button>
      </div>

      <!-- Product Info in Three Columns -->
      <div class="header-info-columns">
        <!-- Left Column -->
        <div class="info-column">
          <div class="info-row">
            <span class="info-label">Product ID :</span>
            <span class="info-value">{{ product?.productId || product?.productDetailsSnapshot?.productId || lead?.productDetailsSnapshot?.productId || 'N/A' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Product Category :</span>
            <span class="info-value">
              {{ product?.category?.name || lead?.category?.name || 'N/A' }}
              <span *ngIf="(product?.category?.categoryId || lead?.category?.categoryId)"> ({{ product?.category?.categoryId || lead?.category?.categoryId }})</span>
            </span>
          </div>
          <div class="info-row">
            <span class="info-label">Supplier ID :</span>
            <span class="info-value" *ngIf="!this.isSupplier" (click)="viewSupplier(this.lead.supplier); $event.preventDefault(); $event.stopPropagation()">
              {{ this.lead?.supplier?.supplierId}}
              <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
              <span class="info-value" *ngIf="this.isSupplier">
                {{ this.lead?.supplier?.supplierId}}
               
                </span>
          </div>
        </div>

        <!-- Middle Column -->
        <div class="info-column">
          <div class="info-row" *ngIf="!this.isSupplier">
            <span class="info-label">Product Created on</span>
            <div class="info-value-wrapper">
              <!-- <span class="info-format-hint">(DD/MM/YYYY)</span> -->
              <span class="info-value">: {{ formatDate(product?.createdAt || product?.productDetailsSnapshot?.createdAt || lead?.productDetailsSnapshot?.createdAt) }}</span>
            </div>
          </div>
          <div class="info-row">
            <span class="info-label">Product Shared on</span>
            <div class="info-value-wrapper">
              <!-- <span class="info-format-hint">(DD/MM/YYYY)</span> -->
              <span class="info-value">: {{ formatDate(lead?.sharedOn || lead?.sharedAt || lead?.createdAt) }}</span>
            </div>
          </div>
        </div>

        <!-- Right Column - Product Image -->
        <div class="info-column image-column">
          <div class="product-image-section">
            <h3 class="product-image-heading">Product Image</h3>
            <div class="product-image-container">
              <div class="image-placeholder" *ngIf="!getProductImageUrl()">
                <div class="no-image-content">
                  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="60" height="60" fill="#e5e7eb" rx="4"/>
                    <path d="M30 18L37.5 27H22.5L30 18Z" fill="#9ca3af"/>
                    <rect x="15" y="30" width="30" height="18" fill="#9ca3af"/>
                  </svg>
                  <span class="no-image-text">No Image</span>
                </div>
              </div>
              <img *ngIf="getProductImageUrl()" 
                   [src]="getProductImageUrl()" 
                   [alt]="product.name"
                   class="product-main-image">
              <div class="image-view-button-container" *ngIf="getProductImageUrl()">
                <button class="btn-view-image" (click)="viewProductImage()">
                  View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <div class="tabs-container">
      <div class="tabs">
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'specification'"
          (click)="switchTab('specification')">
          Specification
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'quote'"
          (click)="switchTab('quote')">
          Quote
        </button>
      </div>
    </div>

    <!-- Specification Tab -->
    <div class="tab-content" data-tab="specification" *ngIf="activeTab === 'specification'">
      <div class="specifications-section">
        <h4>Specifications</h4>
        <table class="specifications-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let spec of getSpecifications(); let i = index">
              <td class="sno-cell">{{ i + 1 }}</td>
              <td class="key-cell">{{ spec.key }}</td>
              <td class="value-cell">
                <div *ngIf="spec.keyType === 'Link'" class="link-container">
                  <a [href]="spec.value" target="_blank" class="link-value">{{ spec.value }}</a>
                </div>
                <div *ngIf="spec.keyType === 'Upload'" class="file-container">
                  <a [href]="spec.value" target="_blank" class="file-link">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="file-icon">
                      <path d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H8L10 4H12C13.1046 4 14 4.89543 14 6Z" stroke="#1e40af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="file-name">{{ getFileName(spec.value) }}</span>
                  </a>
                  <div class="file-size">(File size - {{ getFileSize(spec.value) }})</div>
                </div>
                <div *ngIf="spec.keyType !== 'Link' && spec.keyType !== 'Upload'" class="text-container" [innerHTML]="formatSpecValue(spec.value)"></div>
              </td>
            </tr>
            <tr *ngIf="getSpecifications().length === 0">
              <td colspan="3" class="no-data">No specifications available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Quote Tab -->
    <div class="tab-content" data-tab="quote" *ngIf="activeTab === 'quote'">
      <form [formGroup]="quoteForm" (ngSubmit)="submitQuote()">
        <!-- Order Terms & Validity Section -->
        <div class="quote-section">
          <h4>Order Terms & Validity</h4>
          <div class="form-row">
            <div class="form-group">
              <label>Shipping Term</label>
              <input 
                type="text" 
                [value]="getShippingTerm()" 
                class="form-control"
                readonly>
            </div>
            <div class="form-group">
              <label>Valid Upto <span class="required" *ngIf="isQuoteEditable()">*</span></label>
              <input 
                type="date" 
                formControlName="validityDate" 
                class="form-control date-input"
                [min]="getTodayDate()"
                [readonly]="!isQuoteEditable()"
                [class.invalid]="quoteForm.get('validityDate')?.invalid && quoteForm.get('validityDate')?.touched && isQuoteEditable()"
                [placeholder]="isQuoteEditable() ? '' : 'DD/MM/YYYY'"
                (click)="openDatePicker($event)"
                (focus)="openDatePicker($event)"
                (keydown)="preventManualDateInput($event)"
                (paste)="$event.preventDefault()">
              <div *ngIf="quoteForm.get('validityDate')?.invalid && quoteForm.get('validityDate')?.touched && isQuoteEditable()" class="error-text">
                Valid Upto date is required
              </div>
              <!-- <div *ngIf="!isQuoteEditable() && lead?.validityDate" class="readonly-date-display">
                {{ formatDate(lead.validityDate) }}
              </div> -->
            </div>
          </div>
          <div class="form-group">
            <label>Shipping Address</label>
            <div class="shipping-address-text">{{ getShippingAddress() }}</div>
          </div>
        </div>

        <!-- Quotation Section -->
        <div class="quote-section">
          <h4>Quotation</h4>
          <div formArrayName="quantityPrices" *ngIf="quoteForm && quantitiesInitialized">
            <table class="quotation-table">
              <thead>
                <tr>
                  <th>Quantity</th>
                  <th>UOM</th>
                  <th>Mandatory</th>
                  <th>Per Unit Price</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="quantityPrices && quantityPrices.length > 0; else noQuantities">
                  <tr *ngFor="let priceGroup of quantityPrices.controls; let i = index; trackBy: trackByIndex" [formGroupName]="i">
                    <td class="quantity-cell">
                      {{ priceGroup.get('quantity')?.value ? formatNumber(priceGroup.get('quantity')?.value) : '-' }}
                      <span *ngIf="priceGroup.get('isMandatory')?.value" class="required-asterisk">*</span>
                    </td>
                    <td class="uom-cell">{{ priceGroup.get('uom')?.value || '-' }}</td>
                    <td class="mandatory-cell">
                      <span *ngIf="priceGroup.get('isMandatory')?.value === true" class="mandatory-badge">Yes</span>
                      <span *ngIf="priceGroup.get('isMandatory')?.value === false || priceGroup.get('isMandatory')?.value === null || priceGroup.get('isMandatory')?.value === undefined" class="optional-badge">No</span>
                    </td>
                    <td class="price-cell">
                      <div class="price-input-wrapper">
                        <input 
                          type="number" 
                          formControlName="unitPrice" 
                          class="form-control price-input"
                          [placeholder]="priceGroup.get('isMandatory')?.value ? 'Enter price *' : 'Enter price'"
                          step="0.01"
                          min="0"
                          [readonly]="!isQuoteEditable()"
                        (input)="calculateTotalPrice(i); $event.stopPropagation()"
                        (keyup)="calculateTotalPrice(i)"
                        (keydown)="calculateTotalPrice(i)"
                        (change)="calculateTotalPrice(i)"
                        (blur)="calculateTotalPrice(i)"
                          [class.invalid]="priceGroup.get('unitPrice')?.invalid && priceGroup.get('unitPrice')?.touched && isQuoteEditable()">
                        <span class="currency">INR</span>
                      </div>
                      <div *ngIf="priceGroup.get('unitPrice')?.invalid && priceGroup.get('unitPrice')?.touched && isQuoteEditable()" class="error-text">
                        <span *ngIf="priceGroup.get('unitPrice')?.errors?.['required']">Price is required</span>
                        <span *ngIf="priceGroup.get('unitPrice')?.errors?.['min']">Price must be greater than 0</span>
                      </div>
                    </td>
                    <td class="total-cell"> <span class="currency">INR</span>
                      <span *ngIf="getTotalPrice(priceGroup) > 0; else noTotalPrice">
                        {{ formatNumber(getTotalPrice(priceGroup)) }}
                      </span>
                     
                      <ng-template #noTotalPrice>--</ng-template>
                      
                    </td>
                  </tr>
                </ng-container>
                <ng-template #noQuantities>
                  <tr>
                    <td colspan="5" class="no-quantities-message">No quantities available</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Submit Button - Only show for "Yet to Quote" status from Leads section -->
        <div class="submit-section" *ngIf="isQuoteEditable()">
          <button 
            type="button" 
            class="btn-submit"
            [disabled]="submitting || quoteForm.invalid || !areMandatoryQuantitiesFilled()"
            (click)="submitQuote()">
            <span *ngIf="!submitting">Submit Quote</span>
            <span *ngIf="submitting" class="submit-loading">
              <svg class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416" stroke-linecap="round">
                  <animate attributeName="stroke-dasharray" dur="1.5s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                  <animate attributeName="stroke-dashoffset" dur="1.5s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                </circle>
              </svg>
              Submitting...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Confirmation Modal -->
  <app-confirmation-modal
    [isOpen]="showConfirmModal"
    [message]="confirmModalMessage"
    [confirmText]="'Confirm'"
    [cancelText]="'Cancel'"
    (confirm)="onConfirmSubmit()"
    (cancel)="onCancelSubmit()"
    (close)="closeConfirmModal()">
  </app-confirmation-modal>

  <!-- Image View Modal -->
  <div class="image-modal-overlay" *ngIf="showImageModal" (click)="closeImageModal()">
    <div class="image-modal-content" (click)="$event.stopPropagation()">
      <div class="image-modal-header">
        <span class="image-modal-title">{{ modalImageName }}</span>
        <button class="image-modal-close" (click)="closeImageModal()" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="image-modal-body">
        <img [src]="modalImageUrl" [alt]="modalImageName" class="modal-image">
      </div>
      <div class="image-modal-footer">
        <button class="btn-download" (click)="downloadImage()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2.5V12.5M10 12.5L6.25 8.75M10 12.5L13.75 8.75M3.75 12.5V15.8333C3.75 16.75 4.5 17.5 5.41667 17.5H14.5833C15.5 17.5 16.25 16.75 16.25 15.8333V12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Download</span>
        </button>
      </div>
    </div>
  </div>
</div>
